import { create } from 'zustand';

// The small amount of local UI state: the command palette and the reader
// chrome. Server state lives in TanStack Query.
interface ChromeState {
  palette: boolean;
  readerPanel: 'none' | 'type' | 'contents';
  /**
   * A question asked in the field under the reader's past conversations: the
   * reader opens its Ask panel on it, about the book, and takes it (sets it
   * back to null).
   */
  readerQuestion: string | null;
  /**
   * The address the feedback panel was opened on, and null while it is
   * closed: moving to another page closes it. On a narrow window the
   * account menu opens it, as the top bar has no room for the button
   * (Feedback.tsx).
   */
  feedbackOn: string | null;
  /**
   * Whether the reader's past conversations are open (AskDock): from the
   * round button in the page's corner, or on a phone's page, which has no
   * room for that, from the spark in the bar.
   */
  past: boolean;
  setPalette: (open: boolean) => void;
  setReaderPanel: (p: ChromeState['readerPanel']) => void;
  askInReader: (question: string | null) => void;
  openFeedback: (on: string | null) => void;
  openPast: (open: boolean) => void;
}

export const useChrome = create<ChromeState>((set) => ({
  palette: false,
  readerPanel: 'none',
  readerQuestion: null,
  feedbackOn: null,
  past: false,
  setPalette: (palette) => set({ palette }),
  setReaderPanel: (readerPanel) => set({ readerPanel }),
  askInReader: (readerQuestion) => set({ readerQuestion }),
  openFeedback: (feedbackOn) => set({ feedbackOn }),
  openPast: (past) => set({ past }),
}));
